import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Local testing against the Firebase emulators (e.g. checking firestore.rules
// end to end). Off unless REACT_APP_USE_FIREBASE_EMULATORS=true at build time.
if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
  const authHost = process.env.REACT_APP_AUTH_EMULATOR_HOST || '127.0.0.1:9099';
  const [firestoreHost, firestorePort] = (process.env.REACT_APP_FIRESTORE_EMULATOR_HOST || '127.0.0.1:8080').split(':');
  connectAuthEmulator(auth, `http://${authHost}`, { disableWarnings: true });
  connectFirestoreEmulator(db, firestoreHost, Number(firestorePort));
}

// Export the app instance
export default app;